module.exports = __webpack_public_path__ + "img/art_7_6.8f5afef7.png";